import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button as HeadlessButton } from '@flywire/react-headlessui';
import { cx } from '../../utils/cx';
const baseClasses = 'transition-all cursor-pointer items-center justify-center whitespace-nowrap text-wrap px-4 py-3 text-center text-base normal-case shadow-sm transition-all hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2';
const shapeClasses = {
    circular: 'rounded-full',
    rounded: 'rounded',
    square: 'rounded-none'
};
const sizeClasses = {
    auto: 'inline-flex min-w-36 flex-shrink-0 flex-grow-0 px-6 text-base',
    full: 'flex w-full flex-grow text-base'
};
const toneClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 hover:text-white focus-visible:outline-black active:bg-blue-800 disabled:bg-blue-600/50',
    secondary: 'border border-gray-300 bg-white text-blue-600 hover:!bg-gray-50 hover:text-blue-600 focus-visible:border-white focus-visible:outline-black active:!bg-gray-300 disabled:bg-white disabled:text-blue-50',
    error: 'bg-red-600 text-white hover:bg-red-700 hover:text-white focus-visible:outline-black active:bg-red-800 disabled:bg-red-600/50'
};
export const useButtonClasses = ({ shape = 'rounded', size = 'auto', tone = 'primary', className }) => {
    return cx(baseClasses, shapeClasses[shape], sizeClasses[size], toneClasses[tone], className);
};
const Button = forwardRef(({ shape = 'rounded', size = 'auto', tone = 'primary', className, ...rest }, ref) => {
    const classes = useButtonClasses({ shape, size, tone, className });
    return (_jsx(HeadlessButton, { ref: ref, type: "button", className: classes, "data-tone": tone, ...rest }));
});
Button.displayName = 'Button';
export { Button };
//# sourceMappingURL=Button.js.map